import React from 'react'
import AdminNurseDetailContext from '../context'
import { DocumentType } from 'types/types'
import Loading from 'components/Loading'
import { Box, Chip } from '@mui/material'
import { Outlet, useNavigate } from 'react-router'
import { adminNurseDocumentVerifyURL, adminNurseExperienceURL, adminNurseWorkReferenceURL } from 'routes/urls'
import { 
    getComplianceFromDocumentType,
    ComplianceChip
} from 'components/DocumentUpload'


const DOC_TYPES: DocumentType[] = [
    'gdc',
    'indemnity_insurance',
    'hepatitis_b_vaccination',
    'hepatitis_c',
    'tb',
    'hiv',
    'dbs',
    'pvg',
    'infection_control',
    'cpr',
    'resume',
    'sedation_certificate',
    'radiography_certificate',
]

const AdminNurseDocumentList: React.FC = () => {
    const { nurse } = React.useContext(AdminNurseDetailContext)
    const navigate = useNavigate()

    const compliances = React.useMemo(() => {
        if (!nurse) return []
        return DOC_TYPES.map(docType => getComplianceFromDocumentType(docType, nurse))
    }, [nurse])

    if (!nurse) {
        return <Loading />
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                {compliances.map(compliance => (
                    <ComplianceChip 
                        key={compliance.docType} 
                        compliance={compliance} 
                        onClick={() => navigate(adminNurseDocumentVerifyURL(nurse.nurse_id, compliance.docType))} 
                        size='small'
                    />
                ))}
                <Chip 
                    label='Implant'
                    color={nurse.implant_experience_color}
                    onClick={() => navigate(adminNurseExperienceURL(nurse.nurse_id, 'implant'))}
                    size='small'
                />
                <Chip 
                    label='Orthodontics'
                    color={nurse.orthodontics_experience_color}
                    onClick={() => navigate(adminNurseExperienceURL(nurse.nurse_id, 'orthodontics'))}
                    size='small'
                />
                <Chip
                    label={nurse.workReferenceLabel}
                    color={nurse.workReferenceColor}
                    onClick={() => navigate(adminNurseWorkReferenceURL(nurse.nurse_id))}
                    size='small'
                />
            </Box>
            <Outlet />
        </Box>
    )
}

export default AdminNurseDocumentList